import React, { useEffect, useState } from "react";
import styles from './index.module.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMedal, faSearch } from "@fortawesome/free-solid-svg-icons";
import { useNavigate, useParams } from "react-router-dom";
import { verifyCertificate } from "../redux/features/certificate/certificateService";
import { useDispatch, useSelector } from "react-redux";
import Skeleton from "react-loading-skeleton";
import CertificateImage from "../components/Certificate/CertificateImage";
import IBSLogo from "../assets/images/brand/Uni_logo_landscape.png";

const VerificationLayout = () => {
    const { document_ref } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { isLoadingVerification, isCertificateVerified, verifiedCertificate } = useSelector((state) => state.certificate.verifyCertificate);

    const [regNumber, setRegNumber] = useState(null);
    const [certificateImage, setCertificateImage] = useState(null);

    useEffect(() => {
        dispatch(verifyCertificate({ document_ref }));
    }, [document_ref, dispatch]);

    useEffect(() => {
        if (verifiedCertificate) {
            setCertificateImage(null); 
        }
    }, [verifiedCertificate]);

    const handleSearch = (e) => {
        e.preventDefault();
        if (regNumber) {
            navigate(`/document_ref/${regNumber}`);
        }
    };

    return (
        <div className={styles.container}>
            <div className={styles.searchCard}>
                <div className={styles.studentSearchSection}>
                    <input
                        id="regNumber"
                        placeholder="Document Reference Id"
                        type="text"
                        value={regNumber || ''}
                        name="regNumber"
                        onChange={(e) => setRegNumber(e.target.value)}
                        className={styles.searchInput}
                    />
                    <button
                        type="button"
                        className={styles.searchBtn}
                        onClick={handleSearch}
                    >
                        <FontAwesomeIcon icon={faSearch} aria-hidden="true" color="white" />
                    </button>
                </div>
            </div>
            {isLoadingVerification ?
                <div className={styles.verificationCard}>
                    <Skeleton height={50} width={50} customHighlightBackground="linear-gradient(90deg, var(--base-color) 40%, var(--highlight-color) 80%, var(--base-color) 60%)" />
                    <Skeleton height={30} className={styles.titleSk} customHighlightBackground="linear-gradient(90deg, var(--base-color) 40%, var(--highlight-color) 80%, var(--base-color) 60%)" />
                    <Skeleton height={2} className={styles.titleLineSk} customHighlightBackground="linear-gradient(90deg, var(--base-color) 40%, var(--highlight-color) 80%, var(--base-color) 60%)" />
                    <Skeleton height={20} count={3} className={styles.paraSk} customHighlightBackground="linear-gradient(90deg, var(--base-color) 40%, var(--highlight-color) 80%, var(--base-color) 60%)" />
                    <div className={styles.row}>
                        <Skeleton height={20} width={200} customHighlightBackground="linear-gradient(90deg, var(--base-color) 40%, var(--highlight-color) 80%, var(--base-color) 60%)" />
                        <Skeleton height={20} width={200} customHighlightBackground="linear-gradient(90deg, var(--base-color) 40%, var(--highlight-color) 80%, var(--base-color) 60%)" />
                    </div>
                    <Skeleton height={20} width={200} customHighlightBackground="linear-gradient(90deg, var(--base-color) 40%, var(--highlight-color) 80%, var(--base-color) 60%)" />
                </div> :
                isCertificateVerified ?
                    <div className={styles.verificationCard}>
                        <FontAwesomeIcon icon={faMedal} size="4x" color="green" />
                        <h1 className={styles.certificateTitle}>This is a Valid Certificate</h1>
                        <p className={styles.detailsPara}><span className={styles.highlightText}>{verifiedCertificate?.student_name}</span> (<span className={styles.highlightText}>{verifiedCertificate?.document_ref}</span>) has successfully completed <span className={styles.highlightText}>{verifiedCertificate?.course.name}</span> on {verifiedCertificate?.completion_date} from IBSUniversity.</p>
                        <div className={styles.row}>
                            <div className={styles.dateText}>Issue date: {verifiedCertificate?.certificate_date}</div>
                            <div className={styles.dateText}>Completion date: {verifiedCertificate?.completion_date}</div>
                        </div>
                        <img src={IBSLogo} alt="Logo" className={styles.verifyLogoImg}/>
                    </div>
                    :
                    <div className={styles.verificationCard}>
                        <FontAwesomeIcon icon={faMedal} size="4x" color="red" />
                        <h1 className={styles.certificateTitle}>This is not a Valid Certificate</h1>
                        <p>The certificate for this document reference ID was not found.</p>
                    </div>
            }
            {isCertificateVerified && verifiedCertificate && (
                <CertificateImage data={verifiedCertificate} onImageGenerated={setCertificateImage} />
            )}

            {/* Display Generated Image Below */}
            {certificateImage && (
                <div style={{ textAlign: "center", marginTop: "20px" }}>
                    <p>Certificate Preview</p>
                    <img
                        src={certificateImage}
                        alt="Certificate Preview"
                        style={{ width: "100%", maxWidth: "400px", border: "1px solid #ccc" }}
                    />
                </div>
            )}
        </div>
    );
};

export default VerificationLayout;
